"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.format = void 0;
var utils_1 = require("./utils");
var number_1 = require("../number");
var parseToNumber = function (value) {
    return typeof value === 'string'
        ? parseFloat(value)
        : value;
};
var formatCurrency = function (_a) {
    var locale = _a.locale, code = _a.code, value = _a.value;
    return Intl.NumberFormat((0, utils_1.parseLocale)(locale), {
        currency: code,
        style: 'currency',
    }).format(parseToNumber(value));
};
var formatCurrencyToAbbr = function (_a) {
    var locale = _a.locale, code = _a.code, value = _a.value;
    var withoutAbbr = formatCurrency({ locale: locale, code: code, value: value });
    var prefix = withoutAbbr.match(/^[-+]?[^\d]*/);
    var abbr = (0, number_1.formatNumberToAbbr)({ decimalPart: 2, threshold: 1000 })(value);
    return /[^\d]$/.test(abbr) ? "".concat(prefix).concat(abbr.replace(/^[-+]/, '')) : withoutAbbr;
};
/**
 * @param locale  target locale
 * @param option
 * @param option.code  currency code
 * @param option.abbreviated  format with number abbreviation
 * @param value  the value to format
 *
 * @example
 * ```typescript
 * format('en_US', { code: 'USD' })(100) // $100.00
 * format('zh_CN', { code: 'USD' })(100) // US$100.00
 * format('zh-CN', { code: 'USD' })(100) // US$100.00
 * ```
 *
 * @example Format with number abbreviation.
 * ```typescript
 * format('en_US', { code: 'USD', abbreviated: true })(1000 * 1000) // US$1.00M
 * ```
 * */
var format = function (locale, option) { return function (value) {
    var abbreviated = option.abbreviated, code = option.code;
    if (!value && value !== 0) {
        return '';
    }
    return abbreviated
        ? formatCurrencyToAbbr({ locale: locale, code: code, value: value })
        : formatCurrency({ locale: locale, code: code, value: value });
}; };
exports.format = format;
